import type { ReactNode } from "react";

export interface FieldProps {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export function Field({
  label,
  hint,
  error,
  required,
  children,
  className = "",
}: FieldProps) {
  return (
    <label className={`block ${className}`}>
      {label && (
        <div className="flex items-baseline justify-between mb-2">
          <span className="label">
            {label}
            {required && <span className="text-[var(--strike)] ml-1">*</span>}
          </span>
          {hint && <span className="meta">{hint}</span>}
        </div>
      )}
      {children}
      {error && <div className="caption text-[var(--strike)] mt-1.5">{error}</div>}
    </label>
  );
}
